import React, { Component } from 'react'
import BlogPageBody from '../blogpage/BlogPageBody';

export default class BlogPage extends Component {
  render() {
    return (
      <div>
        <BlogPageBody />
      </div>
    )
  }
}
